<template>
  <div>
    <Header />

    <div class="container-fluid points-remaining">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <AdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <h4 class="page-header">
                Dashboard
                <small>Points Remaining by Unit as of {{ date }} </small>
              </h4>
              <hr />
            </div>

            <!-- table -->
            <div class="text-center m-2 border rounded">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th scope="col" class="text-left">
                      <p class="p-0 pl-2 m-0">Unit</p>
                    </th>
                    <th scope="col" class="text-right">
                      <p class="p-0 pl-2 m-0">Points Remaining</p>
                    </th>
                    <th scope="col" class="text-right">
                      <p class="p-0 pl-2 m-0">Dollars</p>
                    </th>
                    <th scope="col" class="text-left">
                      <p class="p-0 pl-2 m-0">Percent</p>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="client in PointsRemainingByUnitList" :key="client.client_id">
                    <td class="text-left">
                      <p class="p-0 pl-2 m-0">{{ client.client_name }}</p>
                    </td>
                    <td class="text-right">
                      <p class=" badge badge-danger pl-1 pr-1" v-if="parseInt(client.points)<0">
                        {{ Math.round(client.points).toLocaleString() }}
                      </p>

                      <p class="badge badge-success pl-1 pr-1" v-else>
                        {{ Math.round(client.points).toLocaleString() }}
                      </p>
                    </td>
                    <td class="text-right">
                      <p class="p-0 pl-2 m-0">${{ client.dollars.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</p>
                    </td>
                    <td class="text-left">
                      <p class="p-0 pl-2 m-0">{{ Math.round(client.percentage * 100) / 100 }}%</p>
                    </td>
                  </tr>
                </tbody>
                <tr>
                  <td class="text-left font-weight-bold">
                    <p class="p-0 pl-2 m-0">Totals</p>
                  </td>
                  <td class="text-right">

                    <p class="badge badge-danger pl-1 pr-1" v-if="parseInt(TotalPointsRemaining)<0">
                      {{ Math.round(TotalPointsRemaining).toLocaleString() }}
                    </p>

                    <p class="badge badge-success pl-1 pr-1" v-else>
                      {{ Math.round(TotalPointsRemaining).toLocaleString() }}
                    </p>
                  </td>
                  <td class="text-right">
                    <p class="p-0 pl-2 m-0">${{ (Math.round(TotalDollars * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</p>
                  </td>
                  <td class="text-left">
                    <p class="p-0 pl-2 m-0">{{ Math.round(TotalPercent) }}%</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';
import moment from 'moment';

let today = moment().format('MM/DD/YYYY');

export default {
  name: 'PointsRemaining',

  data() {
    return {
      date: today,
    };
  },

  components: {
    AdminSidebar,
    Header,
    Footer,
  },

  computed: {
    PointsRemainingByUnitList() {
      return this.$store.getters['pointsRemainingByUnitData/getPointsRemainingByUnitList'];
    },
    TotalPointsRemaining() {
      return this.$store.getters['pointsRemainingByUnitData/getTotalPointsRemaining'];
    },
    TotalDollars() {
      return this.$store.getters['pointsRemainingByUnitData/getTotalDollars'];
    },
    TotalPercent() {
      return this.$store.getters['pointsRemainingByUnitData/getTotalPercent'];
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'dashboardPointsRemaining',
        activeMenu: this.activeMenu ? this.activeMenu : 'dashboard',
      });
    },
  },

  mounted() {
    this.$store.dispatch('pointsRemainingByUnitData/fetchGetPointsRemainingByUnitData');
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.points-remaining {
  min-height: 100%;
  margin: -14px 0 0 0;
}

.badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
</style>
